<template>
	<v-dialog v-model="dialog" width=" 500">
		
		<v-card outlined>
			<v-card-text>
				
				<v-row
					no-gutters
				>
					<template 
						v-for="(item_modal, idx_modal) of info"
					>					
						<v-col 
							:key="idx_modal"
						>
							{{ item_modal }}
							<!-- <v-card>
								<v-card-title
									class="pa-0 secondary"
								>
									{{ item_modal }}
								</v-card-title>
								<v-card-text>
									{{ item_modal }}
								</v-card-text>
							</v-card> -->
						</v-col>
					</template>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
	export default{
		name: 'show_modal',
		props: [
			'info_to_component',
		],
		data: () => ({
			info: {},
			dialog: false,
		}), // data
		created(){
			console.log('create show alert modal')
		}, 
		watch:{
			info_to_component: function(val){
				console.log(val, 'open modal')
				if (val) {
					this.dialog = true;
					// console.log(typeof val == 'string', typeof val == 'object', JSON.stringify(val))  

					this.info = val ; //Object.values(val);
				}
			}, // info to component

			dialog: function(val){
				if (!val) {
					this.$emit('close_component', null);
				}
			}
		}, // watch

	}
</script>